Hideaways.subNav = function() {
    var subNav = new SubNav();
    subNav.init();

    Hideaways._subNav = subNav;
}
